//src/hooks/useSelectedClientCompany.ts
import { useCallback, useEffect, useState } from "react";

export const SELECTED_CLIENT_COMPANY_ID_KEY = "normex:selected-client-company-id";
export const SELECTED_CLIENT_COMPANY_NAME_KEY = "normex:selected-client-company-name";
export const SELECTED_CLIENT_COMPANY_CHANGED_EVENT = "normex:selected-client-company-changed";

export function getSelectedClientCompanyId() {
  return window.localStorage.getItem(SELECTED_CLIENT_COMPANY_ID_KEY);
}

export function getSelectedClientCompanyName() {
  return window.localStorage.getItem(SELECTED_CLIENT_COMPANY_NAME_KEY);
}

export function notifySelectedClientCompanyChanged() {
  window.dispatchEvent(new Event(SELECTED_CLIENT_COMPANY_CHANGED_EVENT));
}

export function setSelectedClientCompany(clientCompany: { id: string; name: string }) {
  window.localStorage.setItem(SELECTED_CLIENT_COMPANY_ID_KEY, clientCompany.id);
  window.localStorage.setItem(SELECTED_CLIENT_COMPANY_NAME_KEY, clientCompany.name);
  notifySelectedClientCompanyChanged();
}

export function clearSelectedClientCompany() {
  window.localStorage.removeItem(SELECTED_CLIENT_COMPANY_ID_KEY);
  window.localStorage.removeItem(SELECTED_CLIENT_COMPANY_NAME_KEY);
  notifySelectedClientCompanyChanged();
}

export function useSelectedClientCompany() {
  const readState = useCallback(
    () => ({
      selectedClientCompanyId: getSelectedClientCompanyId(),
      selectedClientCompanyName: getSelectedClientCompanyName(),
    }),
    [],
  );

  const [state, setState] = useState(readState);

  useEffect(() => {
    const handleChange = () => setState(readState());

    window.addEventListener("storage", handleChange);
    window.addEventListener("focus", handleChange);
    window.addEventListener(SELECTED_CLIENT_COMPANY_CHANGED_EVENT, handleChange);

    return () => {
      window.removeEventListener("storage", handleChange);
      window.removeEventListener("focus", handleChange);
      window.removeEventListener(SELECTED_CLIENT_COMPANY_CHANGED_EVENT, handleChange);
    };
  }, [readState]);

  return state;
}
